import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import style from "./style.module.scss";
export default function Table(props) {
    const tableClass = props.className ? props.className : "";
    let tableRowHighlightClass = "";
    if (props.highlightRowOnHover) {
        tableRowHighlightClass = style["table--highlight-row"];
    }
    return _jsx("table", { className: classNames(style["table"], tableClass, tableRowHighlightClass), children: props.children });
}
